import React from 'react';
import FistToFiveVoteControl from './FistToFiveVoteControl';
import { ApplicationView, useController } from '@aha-app/mvc';
import type VotingSessionWidget from '../../../widgets/VotingSessionWidget';
import VotingSessionController from './controllers/VotingSessionController';

const FistToFiveDetails: React.FC<{ widget: VotingSessionWidget }> = ({
  widget,
}) => {
  const controller = useController(VotingSessionController);
  const userId = controller.userId;

  // Fist to Five votes are global, so they go on the widget object ID
  const vote =
    userId && widget.userHasVotedOnObject(widget.id, userId)
      ? widget.userVotesForObject(widget.id, userId)
      : null;

  return (
    <div className='mb-4'>
      <p className='h-700 color-tertiary mb-4 text-center'>
        {vote === null ? (
          'Choose a vote'
        ) : (
          <span className='color-secondary'>
            You voted
            <span className='pl-1 h-500 font-500 color-primary'>{vote}</span>
          </span>
        )}
      </p>
      <FistToFiveVoteControl
        widget={widget}
        value={vote}
        onChange={value => {
          controller.actionSetVotesForObject(widget.id, value);
        }}
      />
    </div>
  );
};

export default ApplicationView(FistToFiveDetails);
